import { Injectable, inject } from '@angular/core';
import { Event, NavigationStart, Router } from '@angular/router';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ErrorPageService {
  private readonly router = inject(Router);

  isError = new Subject<boolean>();

  constructor() {
    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationStart) {
        this.hide();
      }
    });
  }

  show() {
    this.isError.next(true);
  }

  hide() {
    this.isError.next(false);
  }
}
